import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { UtilityService } from '../../service/utility.service';
import { SessionService } from '../../service/session.service';
import {
  PortalFeatureDirective,
  PortalLoginRequiredDirective,
  PortalButtonDirective,
} from '../../directives';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule,
    RouterOutlet,
    PortalFeatureDirective,
    PortalLoginRequiredDirective,
    PortalButtonDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit {
  LoggedIn = JSON.parse(localStorage.getItem('login') || 'false');
  isMobileMenuOpen: boolean = false;
  isDropdownOpen = false;

  constructor(
    private router: Router,
    private utilityService: UtilityService,
    private sessionService: SessionService,
  ) {}

  ngOnInit() {}

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  // Direct access to portal configuration
  get portalConfig() {
    return this.utilityService.portalConfig;
  }

  logout() {
    this.sessionService.logout();
  }
  navigateToProfile() {
    this.router.navigateByUrl('profile');
  }
  throwError() {
    try {
      throw new Error('Test Error from Angular');
    } catch (error) {
      console.error(error);
    }
  }
  navigateToVendorSignUp() {
    this.router.navigateByUrl('vendor-sign-up');
  }
  navigateToVendorLogin() {
    this.router.navigateByUrl('login');
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }
}
